import React, { useState } from 'react';
import Question from './questions/_Question';
import { Form } from 'react-final-form'
import { gql, useMutation } from '@apollo/client';
import { shouldShow } from "./utils/filterable";
import {providerId} from "./config/envSpecificVariables";

function QuestionnaireForm(props: any) {
  
  const CREATE_CLIENT_VIA_FORM = gql`
  mutation CreateClientViaForm(
  $custom_module_form_id: ID,
  $provider_id: ID,
  $first_name: String,
  $email: String,
  $last_name: String,
  $send_product_recommendation_email: Boolean,
  $form_answers: [FormAnswerInput!]!,
  ) {
    createClientViaForm(input: {custom_module_form_id: $custom_module_form_id,
                        provider_id: $provider_id,
                        first_name: $first_name,
                        email: $email,
                        send_product_recommendation_email: $send_product_recommendation_email,
                        last_name: $last_name,
                        form_answers: $form_answers}) {
      form_answer_group { 
        id
        packages_with_recommended_products_purchase_url
      }
      messages {
        field
        message
      }
    }
  }
`;
  
  const [createClientViaForm, { data, loading, error }] = useMutation(CREATE_CLIENT_VIA_FORM);

  const submitForm = async (values: any) => {

    const firstName = values.form_answers[0]?.answer;
    const emailQuestionId = props.questions.find((question: any) => question.mod_type === "email")?.id

    const email = values.form_answers.find((fa: any) => fa.custom_module_id == emailQuestionId)?.answer;


    const convertedValues = {...values, 
                             provider_id: providerId, 
                             send_product_recommendation_email: true,
                             first_name: firstName,
                             last_name: "-",
                             email: email
                             };

    const {
      data: { createClientViaForm: payload }
    } = await createClientViaForm({variables: convertedValues});
    if (!payload.errors && payload.form_answer_group) {
      setFormSubmitted(true);
      
      if (props.isInStore || !payload.form_answer_group.packages_with_recommended_products_purchase_url) {
        setTimeout(function(){ window.location.reload() }, 15000)
      } else {
        window.location.href = payload.form_answer_group.packages_with_recommended_products_purchase_url
      }

    } else {
      return payload.errors;
    }
  }

  const moveBack = (values: any) => {
    let potentialIndex = questionIndex - 1;
    while (true) {
      const potentialQ = props.questions[potentialIndex]
      if (potentialQ && potentialQ?.custom_module_condition && !shouldShow(potentialQ?.custom_module_condition, values)) {
        potentialIndex = potentialIndex - 1;
      } else {
        break;
      }
    }
    props.setQuestionIndex(potentialIndex)
  }

  const generateInitialValues = (formId: string) => {
     if (!props.questions) {
      return {};
     }

     const faInitialValues = props.questions.map ((question: any) => ({custom_module_id: question.id, label: question.label}));

     return {
      custom_module_form_id: formId,
      form_answers: faInitialValues,

     }
   }
 
 const [formSubmitted, setFormSubmitted] = useState(false);
 const [initialValues, setInitialValues] = useState(generateInitialValues(props.formId));
 const questionIndex = props.questionIndex;
 const setQuestionIndex = props.setQuestionIndex;

  if (!props.questions) {
    return (<h2 className="question-title"> There was an error loading the form </h2>);
  }

  if (formSubmitted) {
    return (
      <div className="question-container">
        { props.isInStore ? 
          <h2 className="question-title"> An email has been sent to you with your recommendations</h2>
          :
          <h2 className="question-title"> You are being taken to view your recommendations</h2>
        }
        <button className="nextButton" onClick={() => window.location.reload()}>Restart</button>
      </div>
    )
  }

  return (
  <Form
    onSubmit={submitForm}
    initialValues={initialValues}
    render={({ handleSubmit, values, submitting }) => (
      <>
      { questionIndex > 0 ?
      <button type="button" className="back-button" 
       onClick={() => moveBack(values)}>
        <span> {`< Back`} </span>
      </button> : null }
      <form onSubmit={handleSubmit}>
      {
      submitting ?
        <div>
      <div>
        <img className="loading-icon" src="/vitamine-v.png"  alt="logo" />
      </div>
      <h2 className="question-title">
        Calculating...
      </h2> 
      </div>
      :
      <>
      <div className="question-container">
        <Question key={props.questions[questionIndex].id} questions={props.questions} baseName={`form_answers[${questionIndex}]`} question={props.questions[questionIndex]} questionIndex={questionIndex} setQuestionIndex={setQuestionIndex} values={values} />
      </div>
      { questionIndex + 1 === props.questions.length ?
          <button className="nextButton" type="submit">Get My Results</button>
        : null
      }
      </> }
      </form>
      </>
      )}
    />
  );
}

export default QuestionnaireForm;
